(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["apparel-preview"] && !Shopify.designMode) return;
  try {
    
function initApparel(scope){scope.querySelectorAll('.aw-preview:not([data-ready])').forEach(button=>{button.dataset.ready='true';button.addEventListener('click',()=>{const pressed=button.getAttribute('aria-pressed')!=='true';button.setAttribute('aria-pressed',String(pressed));button.closest('.aw-hero').classList.toggle('aw-show-alt',pressed);});});}initApparel(document);document.addEventListener('shopify:section:load',event=>initApparel(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fl-clearance-deals"] && !Shopify.designMode) return;
  try {
    
(() => {
  const endpoint = 'https://fishinglure-risk-engine.fishinglure.workers.dev/deals/feed';
  const money = cents => new Intl.NumberFormat('en-IN', {style:'currency', currency:'INR', maximumFractionDigits:2}).format(cents / 100);
  const el = (tag, cls, text) => { const node = document.createElement(tag); if (cls) node.className = cls; if (text !== undefined) node.textContent = text; return node; };
  const https = value => { try { const url = new URL(value); return url.protocol === 'https:' ? url.href : ''; } catch { return ''; } };
  function init(root) {
    if (root.dataset.dealsReady) return;
    root.dataset.dealsReady = 'true';
    const grid = root.querySelector('[data-deals-grid]');
    let offers = [], refreshing = false;
    function visibility() {
      const empty = grid.children.length === 0;
      root.hidden = empty && root.dataset.empty !== 'true';
      root.querySelector('[data-deals-empty]').hidden = !empty;
      root.querySelector('[data-deals-note]').hidden = empty;
    }
    function render() {
      grid.replaceChildren();
      offers.filter(o => Date.parse(o.ends) > Date.now()).slice(0, Number(root.dataset.limit) || 8).forEach(o => {
        if (!https(o.url) || !/^\d+$/.test(o.variant_id)) return;
        const card = el('article', 'fl-deals__card'); card.dataset.ends = o.ends;
        const link = el('a'); const url = new URL(o.url); url.searchParams.set('variant', o.variant_id); link.href = url.href;
        if (https(o.image)) { const image = el('img', 'fl-deals__image'); image.src = https(o.image); image.alt = o.title; image.loading = 'lazy'; image.width = 300; image.height = 300; link.append(image); }
        link.append(el('h3', '', o.title)); card.append(link);
        if (o.variant !== 'Default Title') card.append(el('p', 'fl-deals__variant', o.variant));
        card.append(el('span', 'fl-deals__saving', 'Save ' + money(o.original - o.price)));
        const price = el('div', 'fl-deals__price', money(o.price)); price.append(el('del', '', money(o.original))); card.append(price);
        const end = el('p', 'fl-deals__ends', 'Ends ' + new Date(o.ends).toLocaleString('en-IN', {dateStyle:'medium', timeStyle:'short', timeZone:'Asia/Kolkata'}) + ' IST'); card.append(end);
        const form = el('form'); form.method = 'post'; form.action = root.dataset.root + 'cart/add';
        const id = el('input'); id.type = 'hidden'; id.name = 'id'; id.value = o.variant_id;
        const quantity = el('input'); quantity.type = 'hidden'; quantity.name = 'quantity'; quantity.value = '1';
        const button = el('button', '', 'Add to cart'); button.type = 'submit'; button.setAttribute('aria-label', 'Add ' + o.title + ' ' + o.variant + ' to cart');
        form.append(id, quantity, button);
        form.addEventListener('submit', event => { if (Date.parse(o.ends) <= Date.now()) { event.preventDefault(); button.disabled = true; button.textContent = 'Offer ended'; refresh(); } });
        card.append(form); grid.append(card);
      }); visibility();
    }
    async function refresh() {
      if (refreshing || !root.isConnected) return;
      refreshing = true;
      try { const response = await fetch(endpoint, {credentials:'omit', cache:'no-store'}); if (!response.ok) throw new Error('Offers unavailable'); const result = await response.json(); offers = result.currency === 'INR' && Array.isArray(result.offers) ? result.offers : []; render(); }
      catch { offers = []; render(); }
      finally { refreshing = false; }
    }
    refresh();
    const expiry = setInterval(() => { if (!root.isConnected) { clearInterval(expiry); clearInterval(poll); return; } grid.querySelectorAll('[data-ends]').forEach(card => { if (Date.parse(card.dataset.ends) <= Date.now()) card.remove(); }); visibility(); }, 1000);
    const poll = setInterval(refresh, 60000);
  }
  document.querySelectorAll('[data-fl-deals]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-fl-deals]').forEach(init));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
document.querySelectorAll('[data-guide-content]').forEach(content => {
  const nav = content.querySelector('[data-guide-contents]');
  if (!nav || nav.dataset.ready) return;
  const headings = [...content.querySelectorAll('h2')].filter(heading => !heading.closest('.article-cta'));
  if (headings.length < 2) return;
  headings.forEach((heading, index) => {
    if (!heading.id) {
      let id = 'guide-topic-' + index;
      while (document.getElementById(id)) id += '-topic';
      heading.id = id;
    }
    const item = document.createElement('li');
    const link = document.createElement('a');
    link.href = '#' + encodeURIComponent(heading.id);
    link.textContent = heading.textContent;
    item.append(link);
    nav.querySelector('ol').append(item);
  });
  nav.dataset.ready = 'true';
  nav.hidden = false;
});

  } catch(e) { console.error(e); }
})();
})();
